import React, {Component} from 'react';

export default class WindowFitter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            scale: 1,
        };
    }

    fitToWindow() {
        var width_scale = window.innerWidth / this.props.width;
        var height_scale = window.innerHeight / this.props.height;
        var scale = Math.min(width_scale, height_scale);

        // don't upscale on large screens
        scale = Math.min(scale, 1);

        this.setState({
            scale: scale,
        });
    }

    componentDidMount() {
        this.fitToWindow();
        window.addEventListener('resize', this.fitToWindow.bind(this));
    }

    // TODO - when receiving new width or height prop, call fitToWindow()
    // TODO - document width/height prop types

    render() {
        return <div 
            ref={(element) => {this.wrapper = element}}
            style={{
                width: this.props.width * this.state.scale + 'px',
                height: this.props.height * this.state.scale + 'px',
                // only required when scaling up
                overflow: 'hidden',
            }}
        >
            <div 
                ref={(element) => {this.scaled_element = element}}
                style={{
                    transformOrigin: '0 0',
                    transform: 'scale(' + this.state.scale + ')',
                }}
            >
                {this.props.children}
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/WindowFitter.js